import imeStatusCard from './../cards/ime-status-card';

window.mce = 'mce' in window ? window.mce : {};

const selectors = {
    dashboard: '.m__dashboard-performance',
    statusCard: '.m__dashboard-card--chart[mce-chart="ime-status"]',
};

/**
 * Setup Dashboard
 * @returns 
 */
function imeDashboardSetup() {
    const dashboard = document.querySelector( selectors.dashboard );
    if (!dashboard) {
        return;
    }

    // Setupdashboard functionality.
    setupDashboard(dashboard);

    // Setup IME Status Cards.
    const statusCards = document.querySelectorAll(selectors.statusCard);
    statusCards.forEach(cardEl => dashboard.addItem(imeStatusCard(cardEl)));

    dashboard.loadAllItems();
}

/**
 * 
 * @param {Element} dashboard 
 */
function setupDashboard(dashboard) {
    let dashboardStartDate = '';
    dashboard.setStartDate = date => {
        dashboardStartDate = date;
    };
    dashboard.getStartDate = () => {
        return dashboardStartDate;
    };

    let dashboardEndDate = '';
    dashboard.setEndDate = date => {
        dashboardEndDate = date;
    };
    dashboard.getEndDate = () => {
        return dashboardEndDate;
    };
    dashboard.setDateInterval = (startDate, endDate) => {
        dashboard.setStartDate(startDate);
        dashboard.setEndDate(endDate);
    };

    const dashboardItems = [];
    dashboard.addItem = item => {
        dashboardItems.push(item);
    };
    dashboard.loadAllItems = () => {
        dashboardItems.forEach(item => item.load());
    };
    dashboard.loadItem = idx => {
        if (dashboardItems[idx]) {
            dashboardItems[idx].load();
        }
    };

    const startDate = new Date(Date.parse(dashboard.dataset.startDate));
    const endDate = new Date(Date.parse(dashboard.dataset.endDate));
    dashboard.setDateInterval(startDate, endDate);
}

export default imeDashboardSetup;